import { FormActionTypes } from './constants';
import { RequestActionTypes } from '../request/constants';

const deepEqual = (obj1, obj2) => {
  if (obj1 === obj2) return true;
  if (obj1 == null || obj2 == null) return false;
  if (typeof obj1 !== 'object' || typeof obj2 !== 'object') return false;

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  for (let key of keys1) {
    if (!keys2.includes(key)) return false;
    if (!deepEqual(obj1[key], obj2[key])) return false;
  }

  return true;
};

let answerUpdateCount = 0;
const MAX_UPDATES_PER_CYCLE = 50;

const resetUpdateCounter = () => {
  setTimeout(() => {
    answerUpdateCount = 0;
  }, 100);
};

export const initialState = {
  page_action: '',
  result_data: [],
  answer_data: {},
  current_index: 0,
  form_length: '',
  request_data: [],
  password_alert: false,
  isReady: false,
  submissionUrl: '',
  backgroundColor: '',
  report_type: '',
  loading: false,
  comments: {},
};

export const reducer = (state = initialState, action) => {
  let data = {};
  let answer = {};
  let current_index;
  data = action.payload;
  switch (action.type) {
    case FormActionTypes.GET_MAIN_PAGE_SUCCESS:
      return {
        ...state,
        current_index: 0,
        submissionUrl: data.submissionUrl,
        password_alert: false,
        backgroundColor: data.backgroundColor,
        report_type: data.report_type,
        loading: false,
      };
    case FormActionTypes.GET_MAIN_PAGE_FAILED:
      return { ...state, request_data: [], isReady: false };
    case FormActionTypes.GET_COMMENTS_SUCCESS:
      return { ...state, comments: data };
    case FormActionTypes.ADD_PAGE_ANSWER:
      // Defensive guard to ensure form data is loaded
      if (!state.request_data || !state.request_data[state.current_index]) {
        console.warn('Attempted to save answer before form data was loaded');
        return state;
      }

      if (++answerUpdateCount > MAX_UPDATES_PER_CYCLE) {
        console.error(
          'Potential infinite loop detected in ADD_PAGE_ANSWER, preventing update'
        );
        resetUpdateCounter();
        return state;
      }

      let components = state.request_data[state.current_index].components || state.request_data[state.current_index].fields || [];
      let component = components.filter((com) => com.key == data.key)[0];

      let comment = null;
      if (answer[data.key] && answer[data.key].comment)
        comment = answer[data.key].comment;
      if (component && !component.comment) comment = false;

      answer = state.answer_data;
      const existingAnswer = answer[data.key];
      const newAnswer = {
        ...answer[data.key],
        key: data.key,
        answer: data.answer,
        comment: comment,
        question_text: data.question_text,
        format: data.format,
      };

      const hasAnswerChanged =
        !existingAnswer || !deepEqual(existingAnswer, newAnswer);
      if (hasAnswerChanged) {
        answer[data.key] = newAnswer;
        resetUpdateCounter();
        return { ...state, answer_data: answer };
      }

      return state;

    case FormActionTypes.ADD_PAGE_COMMENT:
      const newComment = data.comment;
      let newComments;
      if (state.comments[data.key] === undefined) {
        newComments = [newComment];
      } else {
        newComments = [...state.comments[data.key], newComment];
      }

      const updatedComments = { ...state.comments, [data.key]: newComments };

      return { ...state, comments: updatedComments };
    case FormActionTypes.DELETE_FILE_UPLOAD:
      answer = state.answer_data;
      answer[data.key] = {
        ...answer[data.key],
        answer: [],
      };
      return { ...state, answer_data: answer };

    case FormActionTypes.ADD_PAGE_ANSWER_CALENDAR:
      if (++answerUpdateCount > MAX_UPDATES_PER_CYCLE) {
        console.error(
          'Potential infinite loop detected in ADD_PAGE_ANSWER_CALENDAR, preventing update'
        );
        resetUpdateCounter();
        return state;
      }

      let answer_calendar = state.answer_data;
      const newCalendarAnswer = {
        key: data.key,
        answer: data.answer,
        question_text: data.question_text,
        format: data.format,
        rawValue: data.rawValue,
        outputFormat: data.outputFormat,
        timezone: data.timezone,
      };

      const existingCalendarAnswer = answer_calendar[data.key];
      const hasCalendarAnswerChanged =
        !existingCalendarAnswer ||
        !deepEqual(existingCalendarAnswer, newCalendarAnswer);
      if (hasCalendarAnswerChanged) {
        answer_calendar[data.key] = newCalendarAnswer;
        resetUpdateCounter();
        return { ...state, answer_data: answer_calendar };
      }

      return state;

    case FormActionTypes.ADD_PAGE_ANSWER_TABLE:
      if (++answerUpdateCount > MAX_UPDATES_PER_CYCLE) {
        console.error(
          'Potential infinite loop detected in ADD_PAGE_ANSWER_TABLE, preventing update'
        );
        resetUpdateCounter();
        return state;
      }

      let answer_table = state.answer_data;
      const newTableAnswer = {
        key: data.key,
        question_text: data.question_text,
        format: data.format,
        exportFormat: data.exportFormat,
        tableAnswerKeys: data.tableAnswerKeys,
        colNames: data.colNames,
        answer: {
          ...data.answer,
        },
      };

      const existingTableAnswer = answer_table[data.key];
      const hasTableAnswerChanged =
        !existingTableAnswer || !deepEqual(existingTableAnswer, newTableAnswer);
      if (hasTableAnswerChanged) {
        answer_table[data.key] = newTableAnswer;
        resetUpdateCounter();
        return { ...state, answer_data: answer_table };
      }

      return state;

    case FormActionTypes.GET_NEXT_PAGE:
      return { ...state, isReady: true };
    case FormActionTypes.GET_NEXT_PAGE_SUCCESS:
      let targetIndex = action.data.queryParams.index;
      current_index = state.current_index;
      return {
        ...state,
        current_index: targetIndex,
        isReady: true,
        password_alert: false,
        loading: false,
      };
    case FormActionTypes.GO_BACK_TO_PRE:
      let pre_stage = state.request_data;
      current_index = state.current_index;
      return {
        ...state,
        current_index: current_index - 1,
        loading: false,
      };
    case FormActionTypes.GO_BACK_TO_ANY:
      return { ...state, current_index: data.index, loading: false };
    case FormActionTypes.UNMOUNT_FROM:
      return {
        ...state,
        page_action: '',
        result_data: [],
        answer_data: {},
        current_index: 0,
        form_length: '',
        request_data: [],
        password_alert: false,
        isReady: false,
        submissionUrl: '',
        report_type: '',
      };
    case RequestActionTypes.REQUEST_COMPLETED:
      return { ...state };
    case FormActionTypes.PASSWORD_ALERT:
      return { ...state, password_alert: true };
    case FormActionTypes.CLEAR_PASSWORD_ALERT:
      return { ...state, password_alert: false };
    case FormActionTypes.FORM_LOADING:
      return { ...state, loading: true };
    case FormActionTypes.UPDATE_FORM_STATE:
      const { formSession, formMeta } = data;

      // Create init form session and form meta objects
      let formSessionObj = {
        projectSessionId: '',
      };

      let formMetaObj = {};

      // formMeta is { msg, data: { ...actual form data... }, status }
      // The actual form payload is at formMeta.data
      const formPayload = formMeta?.data || formMeta;
      const isV2 = formPayload && (formPayload.schemaVersion >= 2 || Array.isArray(formPayload.pages));
      if (isV2 && formPayload) {
        const rawPages = formPayload.pages;
        const pages = Array.isArray(rawPages)
          ? rawPages.map(page => ({
              ...page,
              components: page.components || page.fields || [],
            }))
          : rawPages;
        formMetaObj['request_data'] = pages;
        formMetaObj['form_length'] = Array.isArray(pages) ? pages.length : Object.keys(pages || {}).length;
        if (formPayload.formTitle !== undefined) formMetaObj['form_title'] = formPayload.formTitle;
        if (formPayload.canSaveSubmission !== undefined) formMetaObj['canSaveSubmission'] = formPayload.canSaveSubmission;
        if (formPayload.autoSave !== undefined) formMetaObj['autoSave'] = formPayload.autoSave;
        if (formPayload.canEditSubmission !== undefined) formMetaObj['canEditSubmission'] = formPayload.canEditSubmission;
        if (formPayload.canAddSubmission !== undefined) formMetaObj['canAddSubmission'] = formPayload.canAddSubmission;
        if (formPayload.submissionUrl !== undefined) formMetaObj['submissionUrl'] = formPayload.submissionUrl;
        if (formPayload.backgroundColor !== undefined) formMetaObj['backgroundColor'] = formPayload.backgroundColor;
      } else if (formMeta && formMeta.data) {
        const v1Pages = formMeta.data.pages;
        if (v1Pages && typeof v1Pages === 'object') {
          const pageEntries = Array.isArray(v1Pages) ? v1Pages : Object.values(v1Pages);
          pageEntries.forEach((page) => {
            if (!page.components && page.fields) {
              page.components = page.fields;
            }
          });
        }
        formMetaObj['request_data'] = v1Pages;
        formMetaObj['form_length'] = formMeta.data.form_length;
      }

      // If form session exists, set the project session id and the answer data
      if (formSession && formSession.data && formSession.data.data) {
        formSessionObj['projectSessionId'] = formSession.data.projectSessionId
          ? formSession.data.projectSessionId
          : '';
        formSessionObj['answer_data'] = formSession.data.data;
      }

      // Create the updated state object and return
      let updatedState = {
        ...state,
        ...formMetaObj,
        ...formSessionObj,
        isReady: true,
      };

      return updatedState;
    default:
      return state;
  }
};

export default reducer;
